import { postJSON, post, get } from '@/utils/axios'

// 案例中心头部统计
interface selectConstructionCaseHeadStatisticsProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    constructionUserPk?: string //施工技师pk
    brandName?: string //品牌名称
    servicePk?: string //服务pk
    status?: string //状态 -1待上传 0-待审核 1-审核通过 2-审核不通过
}
export const selectConstructionCaseHeadStatistics = (options:selectConstructionCaseHeadStatisticsProps) => postJSON('case/selectConstructionCaseHeadStatistics', options)

//案例中心列表
export const getSelectConstructionCaseList = (options:selectConstructionCaseHeadStatisticsProps) => postJSON('case/selectConstructionCaseList', options)

// 服务列表
interface selectProjectListProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    orderBy?: string //排序
    projectName?: string //服务名称
    fastBilling?: string //常用服务(0:否，1:是)
    aiProject?: string //iot项目 0-否 1-是
}
export const getSelectProjectList = (options:selectProjectListProps) => postJSON(`project/selectProjectList`, options)

// 查询云服务
export const getSelectCloudProjectList = (options:selectProjectListProps) => postJSON(`project/selectCloudProjectList`, options)

/**
 * 施工单详情
 * @param receivePk 接车单PK
 * @param constructionBillPk 施工单PK
 * @returns 
 */
export const getSelecConstructionBillDetailByReceivePk = (receivePk:string, constructionBillPk:string) => get(`constructionBill/selecConstructionBillDetailByReceivePk`, {
    receivePk,
    constructionBillPk
})

/**
 * 商户端案例审核
 */
//案例中心头部统计
interface agencySelectConstructionCaseHeadStatisticsProps {
    page?: string | number //当前页
    size?: string  | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    cloudServicesPks?: any //项目pk-多个逗号隔开
    brandName?: string //品牌名称
    province?: string //省
    city?: string //市
    county?: string //县
    orgName?: string //门店名称
    constructionUserPk?: string //施工技师pk
    status?: string //状态 0-待审核 1-审核通过 2-审核不通过
}
export const getSelectConstructionCaseHeadStatistics = (options:agencySelectConstructionCaseHeadStatisticsProps) => postJSON(`/yme-agency/case/selectConstructionCaseHeadStatistics`, options)

//案例中心Table数量统计
export const getAgencySelectConstructionCaseTableCount = (options:agencySelectConstructionCaseHeadStatisticsProps) => postJSON(`/yme-agency/case/selectConstructionCaseTableCount`, options)

//案例中心列表 
export const getagencySelectConstructionCaseList = (options:agencySelectConstructionCaseHeadStatisticsProps) => postJSON(`/yme-agency/case/selectConstructionCaseList`, options)

//根据施工报告PK查询案例中心详情 
export const getSelectConstructionCaseInfo = (reportPk: string) => get(`/yme-agency/case/selectConstructionCaseInfo/${reportPk}`, { reportPk })


//根据施工报告PK查询案例中心详情 
interface updateAuditCasesProps {
    reportPk?: string //施工报告PK
    approvalStatus?: string //商户审核状态 1-审核通过 2-审核不通过
    approvalFailReason?: string //审核不通过原因
}
export const setUpdateAuditCases = (options: updateAuditCasesProps) => postJSON(`/yme-agency/case/updateAuditCases`, options)

// 商户端-商品出入库明细列表头部统计
interface selectPadIotProductInventoryDetailSummaryProps {
    orgPk?: string //门店pk
    page?: string | number //当前页
    productPk?: string //商品pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const getSelectPadIotProductInventoryDetailSummary = (options: selectPadIotProductInventoryDetailSummaryProps) => postJSON(`iotProject/selectPadIotProductInventoryDetailSummary`, options)

//商户端-商品出入库明细列表
export const getSelectPadIotProductInventoryDetailList = (options: selectPadIotProductInventoryDetailSummaryProps) => postJSON(`iotProject/selectPadIotProductInventoryDetailList`, options)

// 商户端-施工记录头部统计
interface selectPadConstructionStatisticsProps {
    page?: string | number //当前页
    equipmentTypePk?: string //设备类型pk
    size?: string | number //每页大小
    status?: string //状态0-待施工 1-施工中 2-已上传
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const getSelectPadConstructionStatistics = (options: selectPadConstructionStatisticsProps) => postJSON(`iotProject/selectPadConstructionStatistics`, options)

//商户端-施工记录
export const getSelectPadConstructionBillList = (options: selectPadConstructionStatisticsProps) => postJSON(`iotProject/selectPadConstructionBillList`, options)

// 查询门店收款记录-头部统计
interface getStoreReceivableListProps {
    page?: string | number //当前页
    storeOrgPk?: string //门店PK
    size?: string | number //每页大小
}
export const getStoreReceivableStatistics = (options: getStoreReceivableListProps) => postJSON(`/yme-agency/receivable/getStoreReceivableStatistics`, options)

// 查询门店收款记录
export const getStoreReceivableList = (options:getStoreReceivableListProps) => postJSON(`/yme-agency/receivable/getStoreReceivableList`, options)

// 获取案例-全部车辆品牌
export const getCaseAllBrandName = () => get(`/yme-agency/caseRanking/getCaseAllBrandName`)

// 获取案例-全部区域(省)
export const getCaseAllProvince = () => get(`/yme-agency/caseRanking/getCaseAllProvince`)

// 获取案例-全部区域(市)
export const getCaseAllCity = () => get(`/yme-agency/caseRanking/getCaseAllCity`)

// 获取案例-全部区域(区)
export const getCaseAllCounty = () => get(`/yme-agency/caseRanking/getCaseAllCounty`)

// 获取案例-全部项目
export const getCaseAllProject = () => get(`/yme-agency/caseRanking/getCaseAllProject`)

// 获取案例排名-头部统计
interface getCaseRankingStatisticsProps {
    page?: number //当前页
    startTime?: string //开始日期
    endTime?: string //截止日期
    size?: number //每页大小
    cloudServicesName?: string //项目名称
    brandName?: string //品牌名称
    province?: string //省
    city?: string //市
    county?: string //县
    orgName?: string //门店名称
}
export const getCaseRankingStatistics = (options:getCaseRankingStatisticsProps) => postJSON(`/yme-agency/caseRanking/getCaseRankingStatistics`, options)

//获取案例排名-技师排名
export const getCaseTechnicianRanking = (options:getCaseRankingStatisticsProps) => postJSON(`/yme-agency/caseRanking/getCaseTechnicianRanking`, options)

//案例中心全部技师
interface selectConstructionCaseTechnicianProps {
    page?: number //当前页
    size?: number //每页大小
}
export const selectConstructionCaseTechnician = (options:selectConstructionCaseTechnicianProps) => postJSON(`/yme-agency/case/selectConstructionCaseTechnician`, options)

// 商户案例审核-查询分账收支记录列表统计
interface selectMerchantDivideAccountsStatisticsProps {
    merchantPk?: any 
    startTime?: any //开始日期
    endTime?: any //截止日期
    servicePk?: any //门店施工服务
    orgPk?: any
	page?: any
	size?: any
	type?: any
}
export const selectMerchantDivideAccountsStatistics = (options:selectMerchantDivideAccountsStatisticsProps) => postJSON(`iotProject/purchase/selectMerchantDivideAccountsStatistics`, options)

// 商户案例审核-查询分账收支记录列表
export const selectMerchantDivideAccountsRecordList = (options:selectMerchantDivideAccountsStatisticsProps) => postJSON(`iotProject/purchase/selectMerchantDivideAccountsRecordList`, options)

